import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medapps': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M118.3 238.4C121.8 225.9 125.2 204.8 131.5 204.8 139.8 206.6 141.1 228.2 150.1 241.4 154.7 217.9 155.4 156.3 164.2 154.7 173.2 154 183.9 221.2 186.2 232.2 196.1 236.3 235.1 238.8 235.1 238.8 237 246.1 211.1 246.4 195.1 246.6 190.5 261.4 189.7 274.3 183.7 274.6 179 274.8 175.5 245.8 166.2 225L156.8 290.5C152.4 303.5 141.3 268 134.9 251.2 131.6 251.1 72.5 249.6 87.3 243.4L118.3 238.4zM228 448C249.2 448 249.2 416 228 416H92C70.8 416 70.8 448 92 448H228zM204 512C225.2 512 225.2 480 204 480H116C94.8 480 94.8 512 116 512H204zM238.2 370.5C241.4 351.6 243.4 334.1 250.1 321.7 258 307 266.2 293.6 274.1 280.7 298.7 240.3 320 205.5 320 155.2 320 69.6 248.2 0 160 0S0 69.6 0 155.2C0 205.4 21.3 240.3 45.9 280.7 53.8 293.6 61.9 307 69.9 321.7 76.6 334.2 78.6 351.5 81.8 370.6 85.3 391.6 117.9 386.3 114.4 365.5 110.8 343.8 108.8 324.8 99.1 306.9 66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32S287 87.3 287 155.2C287 211.3 253.5 246.5 220.9 306.8 211.2 324.8 209.2 344.2 205.6 365.4 202.2 386 234.6 391.8 238.2 370.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/medapps.js
// module id = X5eO
// module chunks = 144